export enum BRAND_KEY {
  criptokuantica = 'criptokuantica',
  bridge_positive = 'bridge_positive',
  impozo = 'impozo',
}
export const BRAND: keyof typeof BRAND_KEY = (process.env.REACT_APP_BRAND ||
  BRAND_KEY.bridge_positive) as keyof typeof BRAND_KEY
